import { PeriscopeTag } from '.';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';
export const PeriscopeTagList = ({ tagIds, parentIndex }) => {
    const { openPeriscope } = usePeriscopeActions();
    const handleTagClick = useCallback((tag) => {
        const { name, id } = tag;
        openPeriscope({
            id,
            name,
            openedFromIndex: parentIndex,
            type: SonarObjectType.SonarTag
        });
    }, [openPeriscope, parentIndex]);
    return (React.createElement(React.Fragment, null, tagIds.map((tagId) => React.createElement(PeriscopeTag, { key: tagId, onTagClick: handleTagClick, tagId: tagId }))));
};
